import React from 'react';
import { Outlet } from 'react-router-dom';
import '../../assets/css/common.css';
import Header from './Header';
import Sidebar from './Sidebar';

const SettingsLayout = () => {
  const settingsItems = [
    { to: "/settings/dashboard", label: "대시보드" },
    { to: "/settings/terms", label: "이용약관 등록" },
    { to: "/settings/terms/history", label: "이용약관 히스토리 관리" },
    { to: "/settings/privacy", label: "개인정보방침 설정" },
    { to: "/settings/privacy/history", label: "개인정보방침 히스토리 관리" },
    { to: "/settings/policy", label: "정보정책 동의여부 조회" },
    { to: "/settings/popup", label: "팝업 관리" },
    { to: "/settings/notice", label: "공지사항 관리" },
    { to: "/settings/faq", label: "FAQ 관리" },
    { to: "/settings/firmware", label: "펌웨어 업로드 관리" },
    { to: "/settings/ai-model", label: "글로벌 AI 모델 관리" },
  ];

  return (
    <div className="wrap">
      <Header />
      <div className="section_area">
        <Sidebar items={settingsItems}/>
        <div className="section_wrap">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SettingsLayout;
